import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'atlas-tab-content-container',
  templateUrl: './content-container.component.html',
  styleUrls: ['./content-container.component.scss']
})
export class ContentContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    const contentContainer = document.querySelector('.content-outer-container');
    const firstContent =  contentContainer.querySelector('.content');

    firstContent.classList.add('active');
  }

}
